import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["isValid"],
  _excluded2 = ["isValid"];
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormAdd = {
  label: "PO",
  value: "",
  isValid: false
};
export default {
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: Object
  },
  data: function data() {
    return {
      gettingList: {
        isPending: false,
        cancellationToken: null,
        items: []
      },
      adding: {
        isConfiguring: false,
        form: {},
        isPending: false,
        cancellationToken: null
      },
      updating: {
        isConfiguring: false,
        form: {},
        isPending: false,
        cancellationToken: null
      },
      deleting: {
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.adding.isPending || this.updating.isPending || this.deleting.isPending;
    },
    isAnyFormConfiguring: function isAnyFormConfiguring() {
      return this.adding.isConfiguring || this.updating.isConfiguring;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.getList();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingList$ca;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingList.isPending = true;
              (_this3$gettingList$ca = _this3.gettingList.cancellationToken) === null || _this3$gettingList$ca === void 0 || _this3$gettingList$ca.cancel();
              _this3.gettingList.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/order-docs-settings/".concat(_this3.order.id_order, "/invoice-additional-fields"), "get", null, true, "api", null, _this.gettingList.cancellationToken).catch(function (e) {
                _this.gettingList.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load invoice additional fields");
                handleErrorData(_this, errorData);
                _this.gettingList.cancellationToken = null;
                throw e;
              });
            case 6:
              response = _context2.sent;
              _this3.gettingList.items = _toConsumableArray(response.data.value);
              _this3.gettingList.isPending = false;
              _this3.gettingList.cancellationToken = null;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    startAddingForm: function startAddingForm() {
      this.adding.form = _objectSpread({}, defaultFormAdd);
      this.adding.isConfiguring = true;
    },
    cancelAddingForm: function cancelAddingForm() {
      this.adding.isConfiguring = false;
      this.adding.form = {};
    },
    saveAddingForm: function saveAddingForm() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$adding$cancell;
        var _this4$adding$form, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.adding.isPending = true;
              (_this4$adding$cancell = _this4.adding.cancellationToken) === null || _this4$adding$cancell === void 0 || _this4$adding$cancell.cancel();
              _this4.adding.cancellationToken = axios.CancelToken.source();
              _this4.adding.form.orderId = _this4.order.id_order;
              _this4$adding$form = _this4.adding.form, isValid = _this4$adding$form.isValid, withoutValid = _objectWithoutProperties(_this4$adding$form, _excluded);
              _this = _this4;
              _context3.next = 8;
              return request("/v1/order-docs-settings/invoice-additional-fields", "post", withoutValid, true, "api", null, _this.adding.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the invoice additional field", true);
                handleErrorData(_this, errorData);
                _this.adding.isPending = false;
                _this.adding.cancellationToken = null;
                throw e;
              });
            case 8:
              _context3.next = 10;
              return _this4.getList();
            case 10:
              _this4.adding.isPending = false;
              _this4.adding.isConfiguring = false;
              _this4.adding.cancellationToken = null;
              _this4.$emit("add");
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    startUpdatingForm: function startUpdatingForm(item) {
      this.updating.form = {
        id: item.id,
        label: item.label,
        text: item.text,
        isValid: true
      };
      this.updating.isConfiguring = true;
    },
    cancelUpdatingForm: function cancelUpdatingForm() {
      this.updating.isConfiguring = false;
      this.updating.form = {};
    },
    saveUpdatingForm: function saveUpdatingForm() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$updating$cance;
        var _this5$updating$form, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.updating.isPending = true;
              (_this5$updating$cance = _this5.updating.cancellationToken) === null || _this5$updating$cance === void 0 || _this5$updating$cance.cancel();
              _this5.updating.cancellationToken = axios.CancelToken.source();
              _this5$updating$form = _this5.updating.form, isValid = _this5$updating$form.isValid, withoutValid = _objectWithoutProperties(_this5$updating$form, _excluded2);
              _this = _this5;
              _context4.next = 7;
              return request("/v1/order-docs-settings/invoice-additional-fields", "put", withoutValid, true, "api", null, _this.updating.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the invoice additional field", true);
                handleErrorData(_this, errorData);
                _this.updating.isPending = false;
                _this.updating.cancellationToken = null;
                throw e;
              });
            case 7:
              _context4.next = 9;
              return _this5.getList();
            case 9:
              _this5.updating.isPending = false;
              _this5.updating.isConfiguring = false;
              _this5.updating.cancellationToken = null;
              _this5.$emit("update");
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$refs.confirm.open("Confirm deletion", "Are you sure you want to delete this additional field ?", {
                color: "red"
              });
            case 2:
              ok = _context5.sent;
              if (ok) _this6.delete(item);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    delete: function _delete(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this7$deleting$cance;
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.deleting.isPending = true;
              (_this7$deleting$cance = _this7.deleting.cancellationToken) === null || _this7$deleting$cance === void 0 || _this7$deleting$cance.cancel();
              _this7.deleting.cancellationToken = axios.CancelToken.source();
              _this = _this7;
              _context6.next = 6;
              return request("/v1/order-docs-settings/invoice-additional-fields/".concat(item.id), "delete", null, true, "api", null, _this.deleting.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete the additional field", true);
                handleErrorData(_this, errorData);
                _this.deleting.cancellationToken = null;
                _this.deleting.isPending = false;
                throw e;
              });
            case 6:
              _context6.next = 8;
              return _this7.getList();
            case 8:
              _this7.deleting.isPending = false;
              _this7.deleting.cancellationToken = null;
              _this7.$emit("delete");
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};